exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inner-9bc37be6{margin:20px}.header-90cd5827{color:#616161}.text-62241535{margin:8px 0 10px 0}\n", ""]);

// Exports
exports.locals = {
	"inner": "inner-9bc37be6",
	"header": "header-90cd5827",
	"text": "text-62241535"
};